import { render, staticRenderFns } from "./P005.vue?vue&type=template&id=68a0423a"
import script from "./P005.vue?vue&type=script&lang=js"
export * from "./P005.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports